import user from "./user.service";
import albums from "./albums.service";
import nft from "./nft.service";

export default {
  user,
  albums,
  nft,
};
